import React, { useState, useEffect } from 'react'
import { Button, Card, Col, Row, Divider, Typography, message, Upload, Modal } from 'antd';
import axios from 'axios';
import { UploadOutlined, CloudUploadOutlined } from '@ant-design/icons';
import { UPLOAD_IMG_WORK_CANCEL } from "../../API/apiUrls";

import * as pdfjsLib from "pdfjs-dist";
import { WorkerMessageHandler } from "pdfjs-dist/build/pdf.worker";

// ✅ สร้าง worker เองจาก WorkerMessageHandler
const pdfWorkerBlob = new Blob(
    ["(" + WorkerMessageHandler.toString() + ")()"],
    { type: "application/javascript" }
);
const pdfWorkerUrl = URL.createObjectURL(pdfWorkerBlob);
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

const { Title, Text } = Typography;

const MainImport = () => {
    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [isModalInfo, setIsModalInfo] = useState(false);
    // const fileUrl = `http://localhost:8010/apimg-pdf/GetImagess/one_images/zenon/pda2qAvz8qfWRFJhoN5Pj61755084549.pdf?token=${token}`;
    const MAX_BATCH_SIZE = 200 * 1024 * 1024; // 200MB
    // const MAX_FILES_PER_BATCH = 50;

    const MAX_FILES_PER_BATCH = 30; // จำกัดชุดละ 30 ไฟล์
    const DELAY_MS = 10000; // 10 วิ
    const [invalidFiles, setInvalidFiles] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);

    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));


    const handleChange = async ({ fileList: newFileList }) => {
        const validFiles = [];
        const invalids = [];

        for (let file of newFileList) {
            if (file.type === "application/pdf") {
                try {
                    const pdfData = await file.originFileObj.arrayBuffer();
                    const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
                    file.pageCount = pdf.numPages;

                    if (pdf.numPages === 2) {
                        validFiles.push(file);
                    } else {
                        invalids.push({ name: file.name, pages: pdf.numPages });
                    }
                } catch (err) {
                    console.error("อ่าน PDF ไม่ได้:", err);
                    invalids.push({ name: file.name, pages: "Error" });
                }
            }
        }

        setFileList(validFiles);

        // ✅ เก็บ invalid ไฟล์ แล้วเปิด modal แค่ครั้งเดียว
        if (invalids.length > 0) {
            setInvalidFiles(invalids);
            setModalVisible(true);
        }
    };

    const splitBatches = (files) => {
        const batches = [];
        let currentBatch = [];
        let currentSize = 0;

        for (let file of files) {
            const fileSize = file.originFileObj.size;

            // ถ้าเกิน limit ขนาดหรือจำนวน ให้เริ่ม batch ใหม่
            if (
                currentBatch.length >= MAX_FILES_PER_BATCH ||
                currentSize + fileSize > MAX_BATCH_SIZE
            ) {
                batches.push(currentBatch);
                currentBatch = [];
                currentSize = 0;
            }

            currentBatch.push(file);
            currentSize += fileSize;
        }

        // อย่าลืม push batch สุดท้าย
        if (currentBatch.length > 0) {
            batches.push(currentBatch);
        }

        return batches;
    };

    const handleUpload = async () => {
        setUploading(true);

        if (fileList.length === 0) {
            message.warning("กรุณาเลือกไฟล์ PDF ก่อนอัปโหลด");
            setUploading(false);
            return;
        }

        const allArePDF = fileList.every(file => file.type === "application/pdf");
        if (!allArePDF) {
            message.error("มีไฟล์ที่ไม่ใช่ PDF อยู่ในรายการ!");
            setUploading(false);
            return;
        }

        // แบ่งเป็น batch ละ 30 ไฟล์
        const batches = [];
        for (let i = 0; i < fileList.length; i += MAX_FILES_PER_BATCH) {
            batches.push(fileList.slice(i, i + MAX_FILES_PER_BATCH));
        }

        try {
            for (let i = 0; i < batches.length; i++) {
                const batch = batches[i];
                const formData = new FormData();
                batch.forEach(file => {
                    formData.append("pdfs", file.originFileObj);
                });

                await axios.post(
                    UPLOAD_IMG_WORK_CANCEL,
                    formData,
                    {
                        headers: { "Content-Type": "multipart/form-data" },
                    }
                );

                // ถ้าไม่ใช่ batch สุดท้าย ให้หน่วง 10 วิ
                if (i < batches.length - 1) {
                    // message.info("รอ 10 วินาทีก่อนอัปโหลดชุดถัดไป...");
                    await delay(DELAY_MS);
                }
            }

            message.success(`อัปโหลดสำเร็จ`);

            // for (let i = 0; i < batches.length; i++) {
            //     const batch = batches[i];
            //     console.log(`>>> เริ่มอัปโหลดชุดที่ ${i + 1}`);
            //     console.log("ไฟล์ใน batch:", batch.map(f => f.name));

            //     await delay(2000); // จำลองว่าใช้เวลาอัปโหลด 2 วิ

            //     console.log(`✅ อัปโหลดชุดที่ ${i + 1} สำเร็จ`);

            //     if (i < batches.length - 1) {
            //         console.log("⏳ รอ 10 วินาที...");
            //         await delay(DELAY_MS);
            //     }
            // }

            setFileList([]);
        } catch (err) {
            console.error(err);
            message.error("เกิดข้อผิดพลาดในการอัปโหลด");
        } finally {
            setUploading(false);
        }
    };

    const openModalPDF = () => {
        setIsModalInfo(true);
    }

    return (
        <>
            <Card
                bordered={false}
                style={{
                    width: 'auto',
                }}
            >
                <Row justify="center" style={{ marginTop: 32 }}>
                    <Col xs={24} sm={20} md={16} lg={12}>
                        <Card
                            bordered={false}
                            style={{
                                borderRadius: 16,
                                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                padding: 24,
                                textAlign: "center",
                                width: "100%",
                            }}
                        >
                            <CloudUploadOutlined style={{ fontSize: 48, color: "#1890ff", marginBottom: 16 }} />
                            <Title level={3}>อัปโหลดไฟล์เอกสารใบตอบรับ</Title>
                            <Text type="secondary">
                                รองรับเฉพาะไฟล์ PDF เท่านั้น สามารถเลือกได้หลายไฟล์
                            </Text>
                            <Divider />

                            <Upload
                                multiple
                                accept="application/pdf"
                                fileList={fileList}
                                onChange={handleChange}
                                beforeUpload={() => false}
                                itemRender={(originNode, file, fileList, actions) => {
                                    return (
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                width: "100%",
                                            }}
                                        >
                                            <span>
                                                📄 {file.name}{" "}
                                                {file.pageCount
                                                    ? `(${file.pageCount} หน้า)`
                                                    : "(กำลังตรวจสอบ...)"}
                                            </span>

                                            {/* ใช้ปุ่ม delete ที่ antd มีมาให้ */}
                                            <span
                                                style={{ cursor: "pointer", color: "red" }}
                                                onClick={actions.remove}
                                            >
                                                🗑️
                                            </span>
                                        </div>
                                    );
                                }}
                                style={{ marginBottom: 16 }}
                            >
                                <Button type="dashed" size="large" icon={<UploadOutlined />}>
                                    เลือกไฟล์ PDF
                                </Button>
                            </Upload>


                            {/* {fileList.map((file) => (
                                <div key={file.uid}>
                                    📄 {file.name} ({file.pageCount || "กำลังตรวจสอบ..."} หน้า)
                                </div>
                            ))} */}

                            <Divider />

                            <Button
                                type="primary"
                                size="large"
                                block
                                onClick={handleUpload}
                                disabled={fileList.length === 0}
                                loading={uploading}
                                style={{ borderRadius: 8 }}
                            >
                                {uploading ? "กำลังอัปโหลด..." : "อัปโหลด"}
                            </Button>
                        </Card>
                    </Col>
                </Row>
            </Card>

            <Modal
                title="ไฟล์ที่มีมากกว่า 2 หน้า"
                open={modalVisible}
                onOk={() => {
                    setInvalidFiles([]);
                    setModalVisible(false);
                }}
                onCancel={() => {
                    setInvalidFiles([]);
                    setModalVisible(false);
                }}
            >
                {invalidFiles.map(f => (
                    <p key={f.name}>
                        📄 {f.name} ({f.pages} หน้า)
                    </p>
                ))}
            </Modal>
        </>
    )
}

export default MainImport;

